export default {"src":"/_next/static/media/wordpress.c81f419e.svg","height":142,"width":142,"blurWidth":0,"blurHeight":0};